import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';

import { Drupal7ServicesModule, DrupalConstants, Settings } from 'ngx-drupal7-services';
import { Observable } from 'rxjs/Rx';

@NgModule({
  declarations: [
    MyApp,
    HomePage
  ],
  imports: [
    BrowserModule,
    Drupal7ServicesModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {
private	 online;
	  constructor () {
	    const drupalSettings: Settings = {
		  apiEndPoint: 'drupalgap',
	      apiHost: 'demo.awri.ch',
	      apiProtocol: 'https',
	      language: 'und',
	      requestTimeout: 5000,
	       allowOffline: true,
	      sessionDays: 90,
	    };
	    DrupalConstants.Settings = drupalSettings;
	    // OPTIONAL
	     DrupalConstants.Instance.handleOffline = this.customHandle;
	     
	  
	  }

	  /**
	   * OPTIONAL
	   * custom http offline handler
	   * you can add sweet alert message for example
	   */
	  customHandle() {
		  this.online=false;
	    alert("custom offline handler! you are offline");
	    return Observable.of();
	  }
	 isonline() {
		  return this.online;
	  }
	}




// WEBPACK FOOTER //
// ./src/app/app.module.ts